import { array, struct } from 'io-ts/Decoder';

import { EntityId } from '../../../../integration/EntityId';

export const Request = struct({
	entityIds: array(EntityId),
});
